<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Novo Parceiro</h3>
            </div>
            <div class="col-auto">
              <b-button @click="voltar">Voltar</b-button>
            </div>
          </div>
        </div>
        <div class="element-box">
          <form @submit.prevent="save">
            <div class="form-row">
              <div class="col-md-4">
                <div class="custom-file">
                  <input class="custom-file-input" type="file" name="logo" id="logo" accept="image/*"
                         @change="processFile($event)">
                  <label id="labelLogo" ref="labelLogo" class="custom-file-label" for="logo">Informe o logo do parceiro</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12 form-group" :class="{'has-danger': errors.has('nome')}">
                <label for="nome">Parceiro</label>
                <input id="nome" name="nome" class="form-control" v-validate="'required'"
                  v-model="parceiro.nome">
                <div
                    v-if="errors.has('nome')"
                    class="help-block form-text text-muted form-control-feedback"
                >{{errors.first('nome')}}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12 form-group" :class="{'has-danger': errors.has('categoria')}">
                <label>Categoria</label>

                <multiselect
                    v-model="parceiro.categorias"
                    :multiple="true"
                    label="name"
                    value="id"
                    track-by="id"
                    placeholder="Selecione uma categoria"
                    :showLabels="false"
                    :options="categorias"
                ></multiselect>

                <div
                    v-if="errors.has('categoria')"
                    class="help-block form-text text-muted form-control-feedback"
                >{{errors.first('categoria')}}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12 form-group" :class="{'has-danger': errors.has('descricao')}">
                <label for="descricao">Sobre o parceiro</label>
                <textarea class="form-control" name="descricao" id="descricao"
                          v-validate="'required'" v-model="parceiro.descricao"
                          cols="30" rows="10"></textarea>
                <div
                    v-if="errors.has('descricao')"
                    class="help-block form-text text-muted form-control-feedback"
                >{{errors.first('descricao')}}</div>
              </div>
            </div>
            <div class="form-row mt-4">
              <div class="col-md-12">
                <h5>Contato</h5>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6 form-group">
                <label>Telefone</label>
                <input type="tel" class="form-control" v-mask="['(##) ####-####', '(##) #####-####']"
                  v-model="parceiro.contato.phone">
              </div>
              <div class="col-md-6 form-group">
                <label>Responsável</label>
                <input placeholder="Nome do responsável" class="form-control"
                  v-model="parceiro.contato.name">
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12 form-group" :class="{'has-danger': errors.has('email')}">
                <label>E-mail</label>
                <input type="email" class="form-control" v-validate="'email'"
                  name="email" id="email" v-model="parceiro.contato.email">
                <div
                    v-if="errors.has('email')"
                    class="help-block form-text text-muted form-control-feedback"
                >{{errors.first('email')}}</div>
              </div>
            </div>

            <div class="form-row mt-4">
              <div class="col-md-12">
                <h5>Endereço</h5>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-3 form-group">
                <label>CEP</label>
                <input type="tel" id="code" name="code" class="form-control"
                   @keyup="buscaCEP()" v-model="endereco.code" v-mask="'#####-###'">
              </div>
              <div class="col form-group">
                <label>Logradouro</label>
                <input id="logradouro" class="form-control" v-model="endereco.street">
              </div>
              <div class="col form-group">
                <label>Bairro</label>
                <input id="bairro" class="form-control" v-model="endereco.neighborhood">
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-4 form-group">
                <label>Número</label>
                <input type="tel" id="numero" class="form-control" v-model="endereco.number">
              </div>
              <div class="col-md-4 form-group">
                <label>Cidade</label>
                <input id="cidade" class="form-control" v-model="endereco.city">
              </div>
              <div class="col-md-4 form-group">
                <label>Estado</label>
                <input id="estado" class="form-control" v-model="endereco.state">
              </div>
            </div>

            <div class="row">
              <div class="col center-block">
                <button class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import axios from 'axios';

export default {
  name: "ParceiroForm",
  components: {
    Multiselect
  },
  async mounted() {
    this.categorias = await axios.get('/api/parceiro/categoria').then(response => response.data);

    await this.loadParceiro();
  },
  computed: {
    empresa() {
      return this.$store.getters.empresa;
    },
    logoText() {
      return this.logo ? this.logo.name : 'Informe o logo do Parceiro';
    }
  },
  data: () => ({
    logo: null,
    imagePreview: null,
    categorias: [],
    endereco: {
      name: null,
      city: null,
      state: null,
      street: null,
      neighborhood: null,
      number: null,
      code: null
    },
    parceiro: {
      nome: null,
      descricao: null,
      categorias: [],
      contato: {
        name: null,
        email: null,
        phone: null
      },
      enderecos: [],
      juridica: null
    }
  }),
  methods: {
    save() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.$store.dispatch('setLoading', true);

          this.parceiro.juridica = this.empresa;
          this.parceiro.enderecos = [];
          this.parceiro.enderecos.push(this.endereco);

          const formData = new FormData();
          formData.append('payload', JSON.stringify(this.parceiro));
          formData.append('logo', this.logo);

          if (this.parceiro._id) {
            formData.append('id', this.parceiro._id);
          }

          await axios.post('/api/parceiro/insert', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });

          this.$store.dispatch('setLoading', false);

          this.$router.push({name: 'ParceiroList'})
        }
      });
    },
    processFile(event){
      this.logo = event.target.files[0];
      this.$refs['labelLogo'].innerHTML = this.logo.name;

      if (this.logo) {
        let file = new FileReader()
        const _self = this
        file.onload = (e) => {
          _self.imagePreview = e.target.result
        }
        file.readAsDataURL(this.logo)
      }
    },
    buscaCEP() {
      if (this.endereco.code) {
        this.endereco.code = this.endereco.code.replace(/[-]/g, '');
        if (this.endereco.code.length === 8) {
          axios.get(`https://viacep.com.br/ws/${this.endereco.code}/json/`)
              .then((result) => {
                let endereco = result.data
                this.endereco.city = endereco.localidade
                this.endereco.neighborhood = endereco.bairro
                this.endereco.street = endereco.logradouro
                this.endereco.state = endereco.uf
              })
        }
      }
    },
    voltar() {
      window.history.back();
    },
    async loadParceiro() {
      const id = this.$route.query['id'];
      if (id) {
        this.$store.dispatch('setLoading', true);
        this.parceiro = await axios.get(`/api/parceiro/${id}`).then(response => response.data);
        this.endereco = this.parceiro.enderecos[0];
        this.$store.dispatch('setLoading', false);
      }
    }
  }
}
</script>

<style scoped>

</style>
